export const ADMIN_APP_ID = 'et-adm';
